import { Link, useUi } from '@weareconceptstudio/core';

//* Helpers
import { config } from '@/helpers';

//* SVG
import logoSVG from './utils';

//* Styles
import LogoStyle from './style';

const Logo = () => {
	const { closeBurgerMenu, isBurgerMenuOpen } = useUi();

	return (
		<LogoStyle className='logo-block'>
			<Link
				onClick={() => {
					if (isBurgerMenuOpen) {
						closeBurgerMenu();
					}
				}}
				url={config.routes.home.path}
				className='logo-wrapper'>
				{logoSVG}
			</Link>
		</LogoStyle>
	);
};

export default Logo;
